import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import TestImageImg from "../../../../../assets/images/joftPooch/pictureTestImg.jpg";
import { useSelector, useDispatch } from "react-redux";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import FileUploader from "./FileUploader";

export default function UploadFileQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion } = useSelector(({ quiz }) => quiz);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    if (currentQuestion) {
      dispatch(
        setQuestionAnswer({
          questionId: currentQuestion._id,
          userFiles: uploadedFiles.map((item) => item.name),
        })
      );
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [uploadedFiles, currentQuestion, dispatch]);

  return (
    <div className="w-100">
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestImageImg
              : TestImageImg
            : TestImageImg
        }
      />
      {currentQuestion?.files &&
        currentQuestion.files.map((item, index) => (
          <FileUploader
            key={index}
            file={item}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
          />
        ))}
    </div>
  );
}
